const ENGLISH_FALLBACKS = {
  "Sobre esta tela": "About this screen",
  Fechar: "Close",
  Usuario: "User",
  Buscar: "Search",
  Mercado: "Market",
  Produtos: "Products",
  "Economize como se estivesse navegando por rotas de preco":
    "Save money as if you were navigating price routes",
  "Cada funcionalidade agora vive em uma pagina propria com taskbar inferior estilo app. O mapa virou a home: ao permitir a localizacao, o app sincroniza automaticamente mercados, farmacias, conveniencias e atacadistas em um raio de {{radius}} milhas.":
    "Each feature now lives on its own page with an app-style bottom taskbar. The map became the home screen: after enabling location, the app automatically syncs markets, pharmacies, convenience stores and wholesalers within a {{radius}} mile radius.",
  "Conta atual": "Current account",
  "{{count}} mercados visiveis no app": "{{count}} markets visible in the app",
  "Cobertura: {{miles}} milhas (~{{km}} km)": "Coverage: {{miles}} miles (~{{km}} km)",
  "Base: {{address}}": "Base: {{address}}",
  "Base ativa pronta para recomendacoes": "Active base ready for recommendations",
  "Navegacao principal": "Primary navigation",
  "Mercados reais no mapa": "Real markets on the map",
  "Toque no mercado para ver o resumo antes de abrir":
    "Tap a market to see the summary before opening it",
  "Ao autorizar a localizacao, o app puxa automaticamente mercados, supermercados, farmacias, conveniencias, atacadistas e varejistas em um raio de {{miles}} milhas do usuario.":
    "After granting location access, the app automatically loads markets, supermarkets, pharmacies, convenience stores, wholesalers and retailers within a {{miles}} mile radius of the user.",
  "Localizando...": "Locating...",
  "Usar minha localizacao": "Use my location",
  "Fechar endereco": "Close address",
  "Adicionar endereco": "Add address",
  "Mercados visiveis": "Visible markets",
  "Raio ativo": "Active radius",
  "Mais proximo": "Closest",
  "Aguardando GPS": "Waiting for GPS",
  "Mapa integrado": "Integrated map",
  "Base da busca": "Search base",
  "Atualizar mapa": "Refresh map",
  "Mercados prontos para abrir": "Markets ready to open",
  "Ranking por distancia": "Distance ranking",
  "Resumo antes de abrir": "Summary before opening",
  "Ir para pagina do mercado": "Go to market page",
  "Lista inteligente": "Smart list",
  "Monte a compra e deixe o app decidir": "Build your shopping list and let the app decide",
  "Configuracoes do usuario": "User settings",
  Permissoes: "Permissions",
  Enderecos: "Addresses",
  Cashback: "Cashback",
  "Central de avisos": "Alerts center",
  "Distancia: {{distance}} | confiabilidade {{confidence}}":
    "Distance: {{distance}} | reliability {{confidence}}",
  "{{freshness}} | provas: {{count}}": "{{freshness}} | proofs: {{count}}",
  "Produtos: {{count}} | contrib.: {{contributions}}":
    "Products: {{count}} | contrib.: {{contributions}}",
  "sem categoria": "uncategorized",
  "preco clube": "club price",
  "Melhor mercado atual": "Current best market",
  "Menor preco": "Lowest price",
  Media: "Average",
  indice: "index",
  "Sem historico suficiente": "Not enough history",
  "Alta de {{amount}}": "Up by {{amount}}",
  "Queda de {{amount}}": "Down by {{amount}}",
  "Preco estavel": "Stable price",
  "Catalogo sincronizado automaticamente": "Catalog synced automatically",
  "Feed automatico consultado": "Automatic feed checked",
  "Sem feed automatico para esta rede": "No automatic feed for this chain",
  "Feed automatico sem itens": "Automatic feed returned no items",
  "Falha na sincronizacao automatica": "Automatic sync failed",
  "{{count}} preco(s) novo(s) entraram no catalogo deste mercado automaticamente.":
    "{{count}} new price entry(ies) were added to this market catalog automatically.",
  "O catalogo automatico foi consultado para este mercado.":
    "The automatic catalog was checked for this market.",
  "A fonte automatica foi consultada e nao trouxe novidades agora.":
    "The automatic source was checked and brought no news right now.",
  "Ainda nao existe uma fonte automatica configurada para esse mercado. O app continua mostrando o catalogo colaborativo.":
    "There is still no automatic source configured for this market. The app keeps showing the collaborative catalog.",
  "Existe uma fonte configurada, mas ela nao devolveu produtos agora.":
    "A source is configured, but it returned no products right now.",
  "Mercado em destaque": "Featured market",
  "Catalogo colaborativo com foco em preco atualizado, confiabilidade e promocoes.":
    "Collaborative catalog focused on updated price, reliability and promotions.",
  Categoria: "Category",
  "Indice {{value}}": "Index {{value}}",
  "Vai melhorando conforme o mercado recebe mais dados.":
    "It improves as the market receives more data.",
  "{{products}} produtos ativos | {{contributions}} atualizacoes":
    "{{products}} active products | {{contributions}} updates",
  "Promocao comunitaria": "Community promotion",
  "modo: {{mode}}": "mode: {{mode}}",
  "exige clube": "club required",
  "Catalogo automatico": "Automatic catalog",
  "fonte {{provider}}": "source {{provider}}",
  "Atualizado em {{date}}": "Updated on {{date}}",
  "Fonte: {{source}} | contribuicoes: {{count}}":
    "Source: {{source}} | contributions: {{count}}",
  Selecionado: "Selected",
  "Promocao atual: {{offer}}": "Current promotion: {{offer}}",
  "Calculo principal": "Main calculation",
  "Atual: {{price}}": "Current: {{price}}",
  "Media 4 ultimos: {{price}}": "Average of last 4: {{price}}",
  "Inflacao 4 ultimos": "Inflation over last 4",
  "Escolha um produto": "Choose a product",
  "Veja o preco atual, a promocao ativa e os 4 ultimos precos desse item neste mercado.":
    "See the current price, the active promotion and the last 4 prices of this item in this market.",
  "Toque em um produto do catalogo para abrir o detalhe e comparar inflacao.":
    "Tap a catalog product to open its details and compare inflation.",
  "Preco atual": "Current price",
  "Promocao: {{offer}}": "Promotion: {{offer}}",
  "Sem promocao informada no momento": "No promotion reported at the moment",
  "Historico analisado": "History analyzed",
  "{{count}} registros": "{{count}} records",
  "O app mostra os 4 ultimos para comparacao rapida.":
    "The app shows the last 4 for quick comparison.",
  "Inflacao local": "Local inflation",
  "Adicione mais atualizacoes deste produto para acompanhar tendencia.":
    "Add more updates for this product to track a trend.",
  "{{sign}}{{value}}% no recorte exibido": "{{sign}}{{value}}% in the displayed range",
  "Ultimos 4 precos neste mercado": "Last 4 prices in this market",
  Atual: "Current",
  "{{count}} leitura(s) atras": "{{count}} reading(s) ago",
  "Assim que voce selecionar um produto do catalogo, o painel mostra preco atual, promocao e tendencia dos ultimos registros.":
    "As soon as you select a catalog product, the panel shows current price, promotion and trend of recent records.",
  "Produto:": "Product:",
  "Preco:": "Price:",
  "Mercado:": "Market:",
  "Oferta:": "Offer:",
  Normal: "Standard",
  Promocao: "Promotion",
  Clube: "Club",
  "Comprovante anexado. Upload #{{id}}": "Proof attached. Upload #{{id}}",
  "Nivel: {{level}} | uploads: {{count}}": "Level: {{level}} | uploads: {{count}}",
  "Favoritos: {{favorites}} | alertas ativos: {{alerts}}":
    "Favorites: {{favorites}} | active alerts: {{alerts}}",
  "Aproximadamente {{distance}} km da base atual":
    "About {{distance}} km from the current base",
  "Nivel {{tier}} | uploads: {{count}}": "Level {{tier}} | uploads: {{count}}",
  "Proximo bonus: {{value}}": "Next bonus: {{value}}",
  "nivel maximo": "max level",
  "Adicione mais leituras para o grafico ganhar forma.":
    "Add more readings so the chart can take shape.",
  "Linha de inflacao": "Inflation line",
  "{{count}} leituras": "{{count}} readings",
  "Voce nao esta logado.": "You are not logged in.",
  "Erro ao enviar imagem.": "Error uploading image.",
  "Processando...": "Processing...",
  "Enviar imagem": "Send image",
  "Extraindo texto da imagem...": "Extracting text from image...",
  "PennyPantry pronto": "PennyPantry ready",
  "Voce vai receber avisos quando os mercados forem atualizados.":
    "You will receive alerts when markets are updated.",
  Inicial: "Initial",
  "Sem recencia": "No recency",
  local: "local",
  "Ranking de mercados atualizado.": "Market ranking updated.",
  "Erro ao carregar notificacoes.": "Error loading notifications.",
  "Entre na conta para salvar favoritos.": "Sign in to save favorites.",
  "Erro ao atualizar favorito.": "Error updating favorite.",
  "Erro ao remover favorito.": "Error removing favorite.",
  "Erro ao atualizar ranking.": "Error refreshing ranking.",
  "Erro ao carregar mercados.": "Error loading markets.",
  "Nao foi possivel consultar mercados reais automaticamente agora.":
    "Could not fetch real markets automatically right now.",
  "Nao foi possivel sincronizar os mercados e lojas do seu raio agora.":
    "Could not sync markets and stores in your area right now.",
  "Mapa de mercados atualizado.": "Market map updated.",
  "Mercados atualizados": "Markets updated",
  "Erro ao sincronizar localizacao.": "Error syncing location.",
  "Selecione um endereco valido na lista de sugestoes antes de salvar.":
    "Select a valid address from the suggestion list before saving.",
  "Erro ao salvar configuracoes.": "Error saving settings.",
  "Erro ao salvar endereco.": "Error saving address.",
  "Erro ao trocar endereco padrao.": "Error changing the default address.",
  "Erro ao remover endereco.": "Error removing address.",
  "Abra uma pagina de produto antes de criar alerta.":
    "Open a product page before creating an alert.",
  "Erro ao criar alerta.": "Error creating alert.",
  "Erro ao remover alerta.": "Error removing alert.",
  "Erro ao atualizar notificacao.": "Error updating notification.",
  "Erro ao abrir o produto.": "Error opening the product.",
  "Digite um produto para comparar.": "Type a product to compare.",
  "Erro ao buscar o produto.": "Error searching for the product.",
  "Catalogo sincronizado automaticamente.": "Catalog synced automatically.",
  "Erro ao sincronizar o catalogo automatico.":
    "Error syncing the automatic catalog.",
  "Este mercado ainda nao tem fonte automatica de produtos e precos. Exibindo o catalogo colaborativo quando houver dados.":
    "This market still has no automatic source for products and prices. Showing the collaborative catalog when data exists.",
  "Erro ao carregar produtos do mercado.": "Error loading market products.",
  "Selecione um mercado no mapa ou na busca antes de abrir a pagina dele.":
    "Select a market on the map or in search before opening its page.",
  "Selecione um mercado antes de adicionar um produto.":
    "Select a market before adding a product.",
  "Selecione um mercado antes de abrir o catalogo.":
    "Select a market before opening the catalog.",
  "Selecao de mercado limpa. Escolha outro marcador no mapa.":
    "Market selection cleared. Choose another marker on the map.",
  "Ponto manual marcado. Para este fluxo novo, priorize tocar em um mercado real e abrir a pagina dele.":
    "Manual point marked. In this new flow, prefer tapping a real market and opening its page.",
  "Informe o produto antes de salvar.": "Enter the product before saving.",
  "Selecione um mercado no mapa ou informe o nome manualmente.":
    "Select a market on the map or enter the name manually.",
  "Erro ao salvar o preco.": "Error saving the price.",
  "Erro ao calcular lista de compras.": "Error calculating shopping list.",
  "Comparativo de mercados atualizado.": "Market comparison updated.",
  "Erro ao comparar mercados.": "Error comparing markets.",
  "Erro ao calcular melhor rota.": "Error calculating the best route.",
  "Erro ao criar alerta da lista.": "Error creating the shopping-list alert.",
  "Erro ao remover alerta da lista.": "Error removing the shopping-list alert.",
  "Mapa sincronizado com os locais reais ao redor da sua posicao.":
    "Map synced with real places around your position.",
  "Erro ao carregar o app.": "Error loading the app.",
  "Buscar produto neste mercado": "Search product in this market",
  "Use a busca para reduzir a lista ou toque em um item para abrir o detalhe.":
    "Use search to narrow the list or tap an item to open details.",
  "Mostrando {{visible}} de {{total}} produtos":
    "Showing {{visible}} of {{total}} products",
  "Nenhum produto encontrado para esta busca.":
    "No products were found for this search.",
  "Digite ao menos 2 letras para procurar direto no catalogo.":
    "Type at least 2 letters to search directly in the catalog.",
};

const ADDITIONAL_ENGLISH_FALLBACKS = {
  "Abrir mapa": "Open map",
  "Abrir mercado": "Open market",
  "Abrir no Google Maps": "Open in Google Maps",
  "Abrir pagina do mercado": "Open market page",
  "Alterar preco": "Change price",
  "Alvo ex: 19,90": "Target ex: 19.90",
  Analytics: "Analytics",
  "Analytics carregando...": "Loading analytics...",
  "Aplicando endereco...": "Applying address...",
  "Aqui ficam os alertas ativos mais importantes.": "Your most important active alerts stay here.",
  "Aqui voce ve distancia, confiabilidade e qualidade do mercado antes de entrar na pagina dele.":
    "See distance, reliability and market quality before opening its page.",
  "Assim que houver mercados sincronizados, eles aparecem aqui e no mapa.":
    "Synced markets appear here and on the map.",
  "Assim que os mercados forem carregados, eles aparecem aqui.":
    "Loaded markets appear here.",
  "Assim que um mercado for selecionado, esta pagina abre o catalogo mais atualizado dele e permite adicionar novos produtos.":
    "After a market is selected, this page opens its latest catalog and lets you add products.",
  "Ative localizacao e notificacoes para receber recomendacoes em tempo real.":
    "Enable location and notifications to receive real-time recommendations.",
  "Ative um alerta para ser avisado quando o total da compra cair abaixo da sua meta.":
    "Enable an alert to be notified when the shopping total drops below your target.",
  "Atualizando catalogo...": "Updating catalog...",
  "Atualizando localizacao...": "Updating location...",
  "Atualizando...": "Updating...",
  "Avaliacao": "Rating",
  "Avaliacao melhora com mais dados.": "Rating improves as more data comes in.",
  "Avaliacao PennyPantry": "PennyPantry rating",
  "Buscas quentes": "Hot searches",
  "Calcule a lista para ver qual mercado vence.": "Calculate the list to see which market wins.",
  "Calcule a melhor rota para combinar preco e deslocamento.":
    "Calculate the best route to combine price and travel distance.",
  "Carteira PennyPantry": "PennyPantry wallet",
  "Central de avisos": "Alert center",
  "Cole a lista uma vez e veja primeiro o mercado mais barato, o mais perto e a melhor combinacao de custo-beneficio.":
    "Paste the list once and see the cheapest, closest and best value markets first.",
  "Comparar mercados": "Compare markets",
  "Comparativo detalhado": "Detailed comparison",
  "Confirmar dados do produto": "Confirm product data",
  "Confirmar mesmo assim": "Confirm anyway",
  "Contribuicoes": "Contributions",
  "contribuicoes acumuladas": "accumulated contributions",
  Coordenadas: "Coordinates",
  "Criar alerta da lista": "Create list alert",
  "Definir como padrao": "Set as default",
  "Disponibilidade": "Availability",
  Dispositivo: "Device",
  "Em celulares, geolocalizacao e notificacoes podem ser limitadas quando o app abre em HTTP pelo IP local.":
    "On phones, geolocation and notifications may be limited when the app opens over HTTP through the local IP.",
  "Encerrar conta": "End session",
  Encontrado: "Found",
  "Endereco ativo": "Active address",
  "Endereco base de busca": "Base search address",
  "Endereco padrao": "Default address",
  Enviando: "Uploading",
  "Enviando comprovante...": "Uploading proof...",
  "Envie uma foto da etiqueta ou nota para aumentar a confiabilidade.":
    "Send a shelf tag or receipt photo to increase reliability.",
  "Escolha como cadastrar o item": "Choose how to add the item",
  "Escolha um item da busca para abrir o painel detalhado.":
    "Choose a search item to open the detail panel.",
  "Escolha um mercado no mapa ou na busca": "Choose a market on the map or search",
  "Esse mercado ainda nao tem produtos cadastrados. Use o botao Add produto para incluir o primeiro.":
    "This market has no products yet. Use Add product to include the first one.",
  "Esses itens estao com promocao declarada, preco clube ou condicao especial nas leituras mais recentes.":
    "These items have a declared promotion, club price or special condition in the latest readings.",
  "Exige clube/membro para liberar esse preco": "Requires club/member access for this price",
  "Favoritar lista": "Favorite list",
  favoritos: "favorites",
  "Fechar add produto": "Close add product",
  "Formulario": "Form",
  "Guarde casa, trabalho e outros pontos para trocar de base rapidamente.":
    "Save home, work and other places to change base quickly.",
  "Ir para pagina do produto": "Go to product page",
  "Itens faltando": "Missing items",
  "Label do endereco: Casa, Trabalho, Praia...": "Address label: Home, Work, Beach...",
  "Ler etiqueta ou nota": "Read shelf tag or receipt",
  "Lista inteligente": "Smart list",
  "Listas monitoradas": "Monitored lists",
  "locais reais carregados": "real places loaded",
  "Mapa integrado": "Integrated map",
  "Marcar como lida": "Mark as read",
  "Media 4 ultimos: {{price}}": "Last 4 average: {{price}}",
  "Melhor mercado": "Best market",
  "Melhor mercado agora": "Best market now",
  "Melhor rota": "Best route",
  "Mercado da lista": "List market",
  "Mercados, contribuicoes e precos suspeitos": "Markets, contributions and suspicious prices",
  "Meta total": "Target total",
  "Monte a compra e deixe o app decidir": "Build the cart and let the app decide",
  "Nao encontrado": "Not found",
  "Nenhum alerta ativo ainda.": "No active alerts yet.",
  "Nenhum alerta de lista ativo ainda.": "No active list alerts yet.",
  "Nenhum mercado encontrado com os filtros atuais.": "No market found with the current filters.",
  "Nenhum preco suspeito carregado.": "No suspicious price loaded.",
  "Nenhuma notificacao por enquanto.": "No notifications yet.",
  "O alerta monitora qualquer mercado dentro do raio salvo para sua localizacao.":
    "The alert monitors any market within the saved radius for your location.",
  "O app tenta reconhecer produto, preco e mercado. Depois voce confirma tudo no formulario abaixo.":
    "The app tries to recognize product, price and market. Then you confirm everything in the form below.",
  "O catalogo mostra apenas o registro mais novo de cada produto. Os antigos continuam guardados no banco para historico e comparacao.":
    "The catalog shows only the newest record for each product. Older entries remain stored for history and comparison.",
  "O mapa agora abre um resumo do mercado antes da pagina completa. Se quiser cadastrar um ponto manual, ainda pode tocar em uma area vazia do mapa.":
    "The map now opens a market summary before the full page. You can still tap an empty map area to add a manual point.",
  "O mercado e a localizacao ja entram travados porque esta pagina sempre cadastra dentro do mercado selecionado.":
    "The market and location are locked because this page always adds products to the selected market.",
  "Oferta ou observacao": "Offer or note",
  "Ofertas em destaque deste mercado": "Featured offers from this market",
  "Os mercados mais perto sobem automaticamente quando a localizacao esta ativa.":
    "Closest markets move up automatically when location is active.",
  "Painel admin": "Admin panel",
  "Painel carregando...": "Loading panel...",
  "Pedir notificacoes": "Request notifications",
  "Pontos salvos": "Saved places",
  "Preco normal": "Regular price",
  "Preco promocional": "Promo price",
  "Precos suspeitos": "Suspicious prices",
  preview: "preview",
  "Produto selecionado": "Selected product",
  "Produtos mais recentes deste mercado": "Latest products from this market",
  "Raio atual": "Current radius",
  "Rota economica": "Savings route",
  "Salvar endereco atual": "Save current address",
  "Salvar produto neste mercado": "Save product in this market",
  "Salve o endereco atual para criar seus pontos favoritos de busca.":
    "Save the current address to create your favorite search places.",
  "Selecione um produto da busca": "Select a product from search",
  "Use este botao para sair do app neste dispositivo.":
    "Use this button to sign out on this device.",
  "Ver produtos": "View products",
  "Voltar ao mapa": "Back to map",
  "Digite rua, numero, bairro ou cidade": "Type street, number, neighborhood or city",
  "Como quer aparecer no app": "How you want to appear in the app",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Search by market, pharmacy, rice, brand, category...",
  "Buscar produto neste mercado": "Search product in this market",
  "Raio maximo em km": "Maximum radius in km",
  "Total alvo ex: 89,90": "Target total ex: 89.90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "One product per line\nRice 5kg\nBeans 1kg\nCoffee 500g",
  Produto: "Product",
  Preco: "Price",
  Marca: "Brand",
  Categoria: "Category",
  "Preco clube": "Club price",
  "Ex.: Cafe 500g": "Ex.: Coffee 500g",
};

Object.assign(ENGLISH_FALLBACKS, ADDITIONAL_ENGLISH_FALLBACKS);

const PT_BR_FALLBACKS = {
  "About this screen": "Sobre esta tela",
  Close: "Fechar",
  "Current account": "Conta atual",
  "Debug code": "Codigo de depuracao",
  "Debug link available only in the local environment.":
    "Link de depuracao disponivel apenas em ambiente local.",
  "Email is required.": "Email obrigatorio.",
  "Email verified. You can sign in now.": "Email confirmado. Agora voce pode entrar.",
  "I already have an account": "Ja tenho conta",
  "Location ready for live recommendations": "Localizacao pronta para recomendacoes ao vivo",
  "Primary navigation": "Navegacao principal",
  "See the fastest path to cheaper groceries":
    "Veja o caminho mais rapido para economizar nas compras",
  "Shopping savings with maps and route intelligence":
    "Economia em compras com mapa e inteligencia de rota",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Comece pelo mapa, atualize sua localizacao e foque nos mercados proximos com maior chance de economia hoje. Raio ativo: {{radius}} milhas.",
  "User": "Usuario",
  "Verification code": "Codigo de verificacao",
  "Verification code is required.": "Codigo de verificacao obrigatorio.",
  "Confirm code": "Confirmar codigo",
  "Confirming...": "Confirmando...",
  "Coverage: {{miles}} mi (~{{km}} km)": "Cobertura: {{miles}} mi (~{{km}} km)",
  "n/a": "n/d",
};

const ES_FALLBACKS = {
  ...ENGLISH_FALLBACKS,
  Buscar: "Buscar",
  Mercado: "Mercado",
  Produtos: "Productos",
  Usuario: "Usuario",
  "Conta atual": "Cuenta actual",
  "Lista inteligente": "Lista inteligente",
  "Configuracoes do usuario": "Configuracion del usuario",
  "Mercados reais no mapa": "Mercados reales en el mapa",
  "Toque no mercado para ver o resumo antes de abrir":
    "Toca un mercado para ver el resumen antes de abrirlo",
  "Usar minha localizacao": "Usar mi ubicacion",
  "Adicionar endereco": "Anadir direccion",
  "Atualizar mapa": "Actualizar mapa",
  "Mercados visiveis": "Mercados visibles",
  "Raio ativo": "Radio activo",
  "Mais proximo": "Mas cercano",
  "Ranking por distancia": "Ranking por distancia",
  "Resumo antes de abrir": "Resumen antes de abrir",
  "Ir para pagina do mercado": "Ir a la pagina del mercado",
  "Add produto": "Anadir producto",
  Favoritar: "Favorito",
  "Remover favorito": "Quitar favorito",
  "Melhor mercado": "Mejor mercado",
  "Comparar mercados": "Comparar mercados",
  "Melhor rota": "Mejor ruta",
  "Abrir no Google Maps": "Abrir en Google Maps",
  "Criar alerta": "Crear alerta",
  "Criar alerta da lista": "Crear alerta de lista",
  "Idioma do app": "Idioma de la app",
  "Salvar configuracoes": "Guardar configuracion",
  "Sair da conta": "Cerrar sesion",
  "See the fastest path to cheaper groceries":
    "Ve la ruta mas rapida para ahorrar en compras",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Empieza en el mapa, actualiza tu ubicacion y enfocate en mercados cercanos con mas oportunidad de ahorro hoy. Radio activo: {{radius}} millas.",
  "Current account": "Cuenta actual",
  User: "Usuario",
  "Coverage: {{miles}} mi (~{{km}} km)": "Cobertura: {{miles}} mi (~{{km}} km)",
  "Location ready for live recommendations": "Ubicacion lista para recomendaciones en vivo",
  "Confirm code": "Confirmar codigo",
  "Confirming...": "Confirmando...",
  "Verification code": "Codigo de verificacion",
  "Verification code is required.": "El codigo de verificacion es obligatorio.",
  "Digite rua, numero, bairro ou cidade": "Escribe calle, numero, barrio o ciudad",
  "Como quer aparecer no app": "Como quieres aparecer en la app",
  "Label do endereco: Casa, Trabalho, Praia...": "Etiqueta de direccion: Casa, Trabajo, Playa...",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Buscar por mercado, farmacia, arroz, marca, categoria...",
  "Buscar produto neste mercado": "Buscar producto en este mercado",
  "Alvo ex: 19,90": "Meta ej.: 19,90",
  "Raio maximo em km": "Radio maximo en km",
  "Total alvo ex: 89,90": "Total meta ej.: 89,90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "Un producto por linea\nArroz 5kg\nFrijoles 1kg\nCafe 500g",
  Produto: "Producto",
  Preco: "Precio",
  "Preco normal": "Precio normal",
  "Preco promocional": "Precio promocional",
  "Preco clube": "Precio club",
  Marca: "Marca",
  Categoria: "Categoria",
  "Oferta ou observacao": "Oferta u observacion",
  "Ex.: Cafe 500g": "Ej.: Cafe 500g",
  "Debug code": "Codigo de depuracion",
  "Debug link available only in the local environment.":
    "Enlace de depuracion disponible solo en entorno local.",
  "Email is required.": "El correo es obligatorio.",
  "Email verified. You can sign in now.":
    "Correo verificado. Ahora puedes entrar.",
};

const IT_FALLBACKS = {
  ...ENGLISH_FALLBACKS,
  Buscar: "Cerca",
  Mercado: "Mercato",
  Produtos: "Prodotti",
  Usuario: "Utente",
  "Conta atual": "Account attuale",
  "Lista inteligente": "Lista intelligente",
  "Configuracoes do usuario": "Impostazioni utente",
  "Mercados reais no mapa": "Mercati reali sulla mappa",
  "Usar minha localizacao": "Usa la mia posizione",
  "Adicionar endereco": "Aggiungi indirizzo",
  "Atualizar mapa": "Aggiorna mappa",
  "Raio ativo": "Raggio attivo",
  "Mais proximo": "Piu vicino",
  "Ranking por distancia": "Classifica per distanza",
  "Ir para pagina do mercado": "Vai alla pagina del mercato",
  "Add produto": "Aggiungi prodotto",
  Favoritar: "Preferito",
  "Remover favorito": "Rimuovi preferito",
  "Melhor mercado": "Miglior mercato",
  "Comparar mercados": "Confronta mercati",
  "Melhor rota": "Miglior percorso",
  "Abrir no Google Maps": "Apri in Google Maps",
  "Criar alerta": "Crea avviso",
  "Criar alerta da lista": "Crea avviso lista",
  "Idioma do app": "Lingua dell'app",
  "Salvar configuracoes": "Salva impostazioni",
  "Sair da conta": "Esci",
  "See the fastest path to cheaper groceries":
    "Vedi il percorso piu rapido per risparmiare sulla spesa",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Inizia dalla mappa, aggiorna la posizione e concentrati sui mercati vicini con piu possibilita di risparmio oggi. Raggio attivo: {{radius}} miglia.",
  "Current account": "Account attuale",
  User: "Utente",
  "Coverage: {{miles}} mi (~{{km}} km)": "Copertura: {{miles}} mi (~{{km}} km)",
  "Location ready for live recommendations": "Posizione pronta per raccomandazioni live",
  "Digite rua, numero, bairro ou cidade": "Scrivi via, numero, quartiere o citta",
  "Como quer aparecer no app": "Come vuoi apparire nell'app",
  "Label do endereco: Casa, Trabalho, Praia...": "Etichetta indirizzo: Casa, Lavoro, Spiaggia...",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Cerca per mercato, farmacia, riso, marca, categoria...",
  "Buscar produto neste mercado": "Cerca prodotto in questo mercato",
  "Alvo ex: 19,90": "Obiettivo es.: 19,90",
  "Raio maximo em km": "Raggio massimo in km",
  "Total alvo ex: 89,90": "Totale obiettivo es.: 89,90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "Un prodotto per riga\nRiso 5kg\nFagioli 1kg\nCaffe 500g",
  Produto: "Prodotto",
  Preco: "Prezzo",
  "Preco normal": "Prezzo normale",
  "Preco promocional": "Prezzo promozionale",
  "Preco clube": "Prezzo club",
  Marca: "Marca",
  Categoria: "Categoria",
  "Oferta ou observacao": "Offerta o nota",
  "Ex.: Cafe 500g": "Es.: Caffe 500g",
  "Confirm code": "Conferma codice",
  "Confirming...": "Conferma...",
  "Verification code": "Codice di verifica",
  "Verification code is required.": "Il codice di verifica e obbligatorio.",
  "Debug code": "Codice debug",
  "Debug link available only in the local environment.":
    "Link debug disponibile solo in ambiente locale.",
  "Email is required.": "Email obbligatoria.",
  "Email verified. You can sign in now.":
    "Email verificata. Ora puoi accedere.",
};

const FR_FALLBACKS = {
  ...ENGLISH_FALLBACKS,
  Buscar: "Recherche",
  Mercado: "Magasin",
  Produtos: "Produits",
  Usuario: "Utilisateur",
  "Conta atual": "Compte actuel",
  "Lista inteligente": "Liste intelligente",
  "Configuracoes do usuario": "Parametres utilisateur",
  "Mercados reais no mapa": "Magasins reels sur la carte",
  "Usar minha localizacao": "Utiliser ma position",
  "Adicionar endereco": "Ajouter une adresse",
  "Atualizar mapa": "Actualiser la carte",
  "Raio ativo": "Rayon actif",
  "Mais proximo": "Le plus proche",
  "Ranking por distancia": "Classement par distance",
  "Ir para pagina do mercado": "Aller a la page du magasin",
  "Add produto": "Ajouter produit",
  Favoritar: "Favori",
  "Remover favorito": "Retirer favori",
  "Melhor mercado": "Meilleur magasin",
  "Comparar mercados": "Comparer les magasins",
  "Melhor rota": "Meilleur trajet",
  "Abrir no Google Maps": "Ouvrir dans Google Maps",
  "Criar alerta": "Creer une alerte",
  "Criar alerta da lista": "Creer une alerte de liste",
  "Idioma do app": "Langue de l'app",
  "Salvar configuracoes": "Enregistrer les parametres",
  "Sair da conta": "Se deconnecter",
  "See the fastest path to cheaper groceries":
    "Voyez le chemin le plus rapide vers des courses moins cheres",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Commencez par la carte, actualisez votre position et ciblez les magasins proches avec les meilleures chances d'economiser aujourd'hui. Rayon actif : {{radius}} miles.",
  "Current account": "Compte actuel",
  User: "Utilisateur",
  "Coverage: {{miles}} mi (~{{km}} km)": "Couverture : {{miles}} mi (~{{km}} km)",
  "Location ready for live recommendations": "Position prete pour les recommandations en direct",
  "Digite rua, numero, bairro ou cidade": "Saisissez rue, numero, quartier ou ville",
  "Como quer aparecer no app": "Nom a afficher dans l'app",
  "Label do endereco: Casa, Trabalho, Praia...": "Libelle d'adresse : Maison, Travail, Plage...",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Rechercher magasin, pharmacie, riz, marque, categorie...",
  "Buscar produto neste mercado": "Rechercher un produit dans ce magasin",
  "Alvo ex: 19,90": "Objectif ex. : 19,90",
  "Raio maximo em km": "Rayon maximum en km",
  "Total alvo ex: 89,90": "Total cible ex. : 89,90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "Un produit par ligne\nRiz 5kg\nHaricots 1kg\nCafe 500g",
  Produto: "Produit",
  Preco: "Prix",
  "Preco normal": "Prix normal",
  "Preco promocional": "Prix promotionnel",
  "Preco clube": "Prix club",
  Marca: "Marque",
  Categoria: "Categorie",
  "Oferta ou observacao": "Offre ou note",
  "Ex.: Cafe 500g": "Ex. : Cafe 500g",
  "Confirm code": "Confirmer le code",
  "Confirming...": "Confirmation...",
  "Verification code": "Code de verification",
  "Verification code is required.": "Le code de verification est obligatoire.",
  "Debug code": "Code de debug",
  "Debug link available only in the local environment.":
    "Lien de debug disponible seulement en environnement local.",
  "Email is required.": "Email obligatoire.",
  "Email verified. You can sign in now.":
    "Email verifie. Vous pouvez vous connecter.",
};

const DE_FALLBACKS = {
  ...ENGLISH_FALLBACKS,
  Buscar: "Suche",
  Mercado: "Markt",
  Produtos: "Produkte",
  Usuario: "Nutzer",
  "Conta atual": "Aktuelles Konto",
  "Lista inteligente": "Smarte Liste",
  "Configuracoes do usuario": "Nutzereinstellungen",
  "Mercados reais no mapa": "Echte Markte auf der Karte",
  "Usar minha localizacao": "Meinen Standort verwenden",
  "Adicionar endereco": "Adresse hinzufugen",
  "Atualizar mapa": "Karte aktualisieren",
  "Raio ativo": "Aktiver Radius",
  "Mais proximo": "Nachste",
  "Ranking por distancia": "Ranking nach Entfernung",
  "Ir para pagina do mercado": "Zur Marktseite",
  "Add produto": "Produkt hinzufugen",
  Favoritar: "Favorit",
  "Remover favorito": "Favorit entfernen",
  "Melhor mercado": "Bester Markt",
  "Comparar mercados": "Markte vergleichen",
  "Melhor rota": "Beste Route",
  "Abrir no Google Maps": "In Google Maps offnen",
  "Criar alerta": "Alarm erstellen",
  "Criar alerta da lista": "Listenalarm erstellen",
  "Idioma do app": "App-Sprache",
  "Salvar configuracoes": "Einstellungen speichern",
  "Sair da conta": "Abmelden",
  "See the fastest path to cheaper groceries":
    "Sieh den schnellsten Weg zu gunstigeren Einkaufen",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Starte auf der Karte, aktualisiere deinen Standort und fokussiere nahe Markte mit den besten Sparchancen heute. Aktiver Radius: {{radius}} Meilen.",
  "Current account": "Aktuelles Konto",
  User: "Nutzer",
  "Coverage: {{miles}} mi (~{{km}} km)": "Abdeckung: {{miles}} mi (~{{km}} km)",
  "Location ready for live recommendations": "Standort bereit fur Live-Empfehlungen",
  "Digite rua, numero, bairro ou cidade": "Strasse, Nummer, Viertel oder Stadt eingeben",
  "Como quer aparecer no app": "Wie du in der App erscheinen willst",
  "Label do endereco: Casa, Trabalho, Praia...": "Adresslabel: Zuhause, Arbeit, Strand...",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Nach Markt, Apotheke, Reis, Marke, Kategorie suchen...",
  "Buscar produto neste mercado": "Produkt in diesem Markt suchen",
  "Alvo ex: 19,90": "Ziel z.B.: 19,90",
  "Raio maximo em km": "Maximaler Radius in km",
  "Total alvo ex: 89,90": "Zielsumme z.B.: 89,90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "Ein Produkt pro Zeile\nReis 5kg\nBohnen 1kg\nKaffee 500g",
  Produto: "Produkt",
  Preco: "Preis",
  "Preco normal": "Normalpreis",
  "Preco promocional": "Aktionspreis",
  "Preco clube": "Clubpreis",
  Marca: "Marke",
  Categoria: "Kategorie",
  "Oferta ou observacao": "Angebot oder Notiz",
  "Ex.: Cafe 500g": "Z.B.: Kaffee 500g",
  "Confirm code": "Code bestatigen",
  "Confirming...": "Wird bestatigt...",
  "Verification code": "Bestatigungscode",
  "Verification code is required.": "Bestatigungscode ist erforderlich.",
  "Debug code": "Debug-Code",
  "Debug link available only in the local environment.":
    "Debug-Link nur in der lokalen Umgebung verfugbar.",
  "Email is required.": "E-Mail ist erforderlich.",
  "Email verified. You can sign in now.":
    "E-Mail bestatigt. Du kannst dich jetzt anmelden.",
};

const PT_PT_FALLBACKS = {
  ...PT_BR_FALLBACKS,
  "Configuracoes do usuario": "Configuracoes do utilizador",
  "Usar minha localizacao": "Usar a minha localizacao",
  "Adicionar endereco": "Adicionar morada",
  "Endereco base de busca": "Morada base de pesquisa",
  "Salvar configuracoes": "Guardar configuracoes",
  "Sair da conta": "Terminar sessao",
  "Confirm code": "Confirmar codigo",
  "Confirming...": "A confirmar...",
  "Verification code": "Codigo de verificacao",
  "Verification code is required.": "Codigo de verificacao obrigatorio.",
  "Email is required.": "Email obrigatorio.",
  "Email verified. You can sign in now.":
    "Email confirmado. Ja pode entrar.",
  "Digite rua, numero, bairro ou cidade": "Digite rua, numero, bairro ou cidade",
  "Como quer aparecer no app": "Como pretende aparecer na app",
  "Label do endereco: Casa, Trabalho, Praia...": "Etiqueta da morada: Casa, Trabalho, Praia...",
  "Buscar por mercado, farmacia, arroz, marca, categoria...":
    "Pesquisar por mercado, farmacia, arroz, marca, categoria...",
  "Buscar produto neste mercado": "Pesquisar produto neste mercado",
  "Alvo ex: 19,90": "Alvo ex.: 19,90",
  "Raio maximo em km": "Raio maximo em km",
  "Total alvo ex: 89,90": "Total alvo ex.: 89,90",
  "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g":
    "Um produto por linha\nArroz 5kg\nFeijao 1kg\nCafe 500g",
  "Preco promocional": "Preco promocional",
  "Oferta ou observacao": "Oferta ou observacao",
  "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.":
    "Comece pelo mapa, atualize a sua localizacao e foque-se nos mercados proximos com maior probabilidade de poupanca hoje. Raio ativo: {{radius}} milhas.",
};

const LANGUAGE_FALLBACKS = {
  "pt-BR": PT_BR_FALLBACKS,
  en: ENGLISH_FALLBACKS,
  es: ES_FALLBACKS,
  it: IT_FALLBACKS,
  fr: FR_FALLBACKS,
  de: DE_FALLBACKS,
  "pt-PT": PT_PT_FALLBACKS,
};

const RUNTIME_TRANSLATIONS = {
  "Favorito salvo.": {
    en: "Favorite saved.",
    es: "Favorito guardado.",
    it: "Preferito salvato.",
    fr: "Favori enregistre.",
    de: "Favorit gespeichert.",
    "pt-PT": "Favorito guardado.",
  },
  "Favorito removido.": {
    en: "Favorite removed.",
    es: "Favorito eliminado.",
    it: "Preferito rimosso.",
    fr: "Favori retire.",
    de: "Favorit entfernt.",
    "pt-PT": "Favorito removido.",
  },
  "Ranking de mercados atualizado.": {
    en: "Market ranking updated.",
    es: "Ranking de mercados actualizado.",
    it: "Classifica mercati aggiornata.",
    fr: "Classement des magasins actualise.",
    de: "Marktranking aktualisiert.",
    "pt-PT": "Ranking de mercados atualizado.",
  },
  "Mapa de mercados atualizado.": {
    en: "Market map updated.",
    es: "Mapa de mercados actualizado.",
    it: "Mappa mercati aggiornata.",
    fr: "Carte des magasins actualisee.",
    de: "Marktkarte aktualisiert.",
    "pt-PT": "Mapa de mercados atualizado.",
  },
  "Localizacao do dispositivo sincronizada com o mapa.": {
    en: "Device location synced with the map.",
    es: "Ubicacion del dispositivo sincronizada con el mapa.",
    it: "Posizione del dispositivo sincronizzata con la mappa.",
    fr: "Position de l'appareil synchronisee avec la carte.",
    de: "Geratestandort mit der Karte synchronisiert.",
    "pt-PT": "Localizacao do dispositivo sincronizada com o mapa.",
  },
  "Endereco aplicado e salvo com sucesso.": {
    en: "Address applied and saved successfully.",
    es: "Direccion aplicada y guardada correctamente.",
    it: "Indirizzo applicato e salvato con successo.",
    fr: "Adresse appliquee et enregistree.",
    de: "Adresse erfolgreich angewendet und gespeichert.",
    "pt-PT": "Morada aplicada e guardada com sucesso.",
  },
  "Endereco aplicado com sucesso. Se quiser manter como padrao, toque em salvar configuracoes.": {
    en: "Address applied successfully. To keep it as default, tap save settings.",
    es: "Direccion aplicada correctamente. Para mantenerla como predeterminada, toca guardar configuracion.",
    it: "Indirizzo applicato. Per mantenerlo predefinito, tocca salva impostazioni.",
    fr: "Adresse appliquee. Pour la garder par defaut, touchez enregistrer les parametres.",
    de: "Adresse angewendet. Um sie als Standard zu behalten, tippe auf Einstellungen speichern.",
    "pt-PT": "Morada aplicada com sucesso. Para manter como predefinida, toque em guardar configuracoes.",
  },
  "Notificacoes habilitadas com sucesso.": {
    en: "Notifications enabled successfully.",
    es: "Notificaciones habilitadas correctamente.",
    it: "Notifiche abilitate con successo.",
    fr: "Notifications activees.",
    de: "Benachrichtigungen erfolgreich aktiviert.",
    "pt-PT": "Notificacoes ativadas com sucesso.",
  },
  "Notificacoes nao foram liberadas.": {
    en: "Notifications were not allowed.",
    es: "Las notificaciones no fueron permitidas.",
    it: "Le notifiche non sono state autorizzate.",
    fr: "Les notifications n'ont pas ete autorisees.",
    de: "Benachrichtigungen wurden nicht erlaubt.",
    "pt-PT": "As notificacoes nao foram autorizadas.",
  },
  "Voce precisa estar logado para salvar configuracoes.": {
    en: "You need to be signed in to save settings.",
    es: "Debes iniciar sesion para guardar configuracion.",
    it: "Devi accedere per salvare le impostazioni.",
    fr: "Vous devez etre connecte pour enregistrer les parametres.",
    de: "Du musst angemeldet sein, um Einstellungen zu speichern.",
    "pt-PT": "Tem de iniciar sessao para guardar configuracoes.",
  },
  "Informe um raio de descoberta valido em milhas.": {
    en: "Enter a valid discovery radius in miles.",
    es: "Introduce un radio de descubrimiento valido en millas.",
    it: "Inserisci un raggio di scoperta valido in miglia.",
    fr: "Indiquez un rayon de decouverte valide en miles.",
    de: "Gib einen gultigen Entdeckungsradius in Meilen ein.",
    "pt-PT": "Informe um raio de descoberta valido em milhas.",
  },
  "Configuracoes da conta salvas. Raio de descoberta atualizado.": {
    en: "Account settings saved. Discovery radius updated.",
    es: "Configuracion de la cuenta guardada. Radio de descubrimiento actualizado.",
    it: "Impostazioni account salvate. Raggio di scoperta aggiornato.",
    fr: "Parametres du compte enregistres. Rayon de decouverte actualise.",
    de: "Kontoeinstellungen gespeichert. Entdeckungsradius aktualisiert.",
    "pt-PT": "Configuracoes da conta guardadas. Raio de descoberta atualizado.",
  },
  "Endereco salvo com sucesso.": {
    en: "Address saved successfully.",
    es: "Direccion guardada correctamente.",
    it: "Indirizzo salvato con successo.",
    fr: "Adresse enregistree.",
    de: "Adresse erfolgreich gespeichert.",
    "pt-PT": "Morada guardada com sucesso.",
  },
  "Entre na conta para criar alertas.": {
    en: "Sign in to create alerts.",
    es: "Entra en la cuenta para crear alertas.",
    it: "Accedi per creare avvisi.",
    fr: "Connectez-vous pour creer des alertes.",
    de: "Melde dich an, um Alarme zu erstellen.",
    "pt-PT": "Entre na conta para criar alertas.",
  },
  "Alerta de queda de preco criado.": {
    en: "Price drop alert created.",
    es: "Alerta de bajada de precio creada.",
    it: "Avviso calo prezzo creato.",
    fr: "Alerte de baisse de prix creee.",
    de: "Preisrutsch-Alarm erstellt.",
    "pt-PT": "Alerta de queda de preco criado.",
  },
  "Lista de compras calculada com sucesso.": {
    en: "Shopping list calculated successfully.",
    es: "Lista de compras calculada correctamente.",
    it: "Lista della spesa calcolata con successo.",
    fr: "Liste de courses calculee.",
    de: "Einkaufsliste erfolgreich berechnet.",
    "pt-PT": "Lista de compras calculada com sucesso.",
  },
  "Comparativo de mercados atualizado.": {
    en: "Market comparison updated.",
    es: "Comparativo de mercados actualizado.",
    it: "Confronto mercati aggiornato.",
    fr: "Comparaison des magasins actualisee.",
    de: "Marktvergleich aktualisiert.",
    "pt-PT": "Comparativo de mercados atualizado.",
  },
  "Rota economica calculada.": {
    en: "Savings route calculated.",
    es: "Ruta economica calculada.",
    it: "Percorso risparmio calcolato.",
    fr: "Trajet economique calcule.",
    de: "Sparroute berechnet.",
    "pt-PT": "Rota economica calculada.",
  },
  "Alerta da lista criado com sucesso.": {
    en: "List alert created successfully.",
    es: "Alerta de lista creada correctamente.",
    it: "Avviso lista creato con successo.",
    fr: "Alerte de liste creee.",
    de: "Listenalarm erfolgreich erstellt.",
    "pt-PT": "Alerta da lista criado com sucesso.",
  },
  "OCR concluido. Revise os dados antes de salvar.": {
    en: "OCR completed. Review the data before saving.",
    es: "OCR concluido. Revisa los datos antes de guardar.",
    it: "OCR completato. Rivedi i dati prima di salvare.",
    fr: "OCR termine. Verifiez les donnees avant d'enregistrer.",
    de: "OCR abgeschlossen. Prufe die Daten vor dem Speichern.",
    "pt-PT": "OCR concluido. Reveja os dados antes de guardar.",
  },
  "OCR concluido com aviso. Revise o preco antes de salvar.": {
    en: "OCR completed with a warning. Review the price before saving.",
    es: "OCR concluido con aviso. Revisa el precio antes de guardar.",
    it: "OCR completato con avviso. Controlla il prezzo prima di salvare.",
    fr: "OCR termine avec avertissement. Verifiez le prix avant d'enregistrer.",
    de: "OCR mit Warnung abgeschlossen. Prufe den Preis vor dem Speichern.",
    "pt-PT": "OCR concluido com aviso. Reveja o preco antes de guardar.",
  },
  "Entre na conta para ativar a assinatura.": {
    en: "Sign in to activate the subscription.",
    es: "Inicia sesion para activar la suscripcion.",
    it: "Accedi per attivare l'abbonamento.",
    fr: "Connectez-vous pour activer l'abonnement.",
    de: "Melde dich an, um das Abonnement zu aktivieren.",
    "pt-PT": "Entre na conta para ativar a subscricao.",
  },
  "Assinatura ativada com sucesso.": {
    en: "Subscription activated successfully.",
    es: "Suscripcion activada correctamente.",
    it: "Abbonamento attivato con successo.",
    fr: "Abonnement active avec succes.",
    de: "Abonnement erfolgreich aktiviert.",
    "pt-PT": "Subscricao ativada com sucesso.",
  },
  "Erro ao ativar assinatura.": {
    en: "Error activating the subscription.",
    es: "Error al activar la suscripcion.",
    it: "Errore durante l'attivazione dell'abbonamento.",
    fr: "Erreur lors de l'activation de l'abonnement.",
    de: "Fehler beim Aktivieren des Abonnements.",
    "pt-PT": "Erro ao ativar a subscricao.",
  },
  "Nao foi possivel carregar o endereco agora.": {
    en: "Could not load the address right now.",
    es: "No se pudo cargar la direccion ahora.",
    it: "Impossibile caricare l'indirizzo adesso.",
    fr: "Impossible de charger l'adresse pour le moment.",
    de: "Die Adresse konnte gerade nicht geladen werden.",
    "pt-PT": "Nao foi possivel carregar a morada agora.",
  },
  "Nao foi possivel entender as coordenadas do dispositivo.": {
    en: "Could not read the device coordinates.",
    es: "No se pudieron interpretar las coordenadas del dispositivo.",
    it: "Impossibile interpretare le coordinate del dispositivo.",
    fr: "Impossible d'interpreter les coordonnees de l'appareil.",
    de: "Die Geratekoordinaten konnten nicht gelesen werden.",
    "pt-PT": "Nao foi possivel interpretar as coordenadas do dispositivo.",
  },
  "Seu dispositivo nao suporta geolocalizacao no navegador.": {
    en: "Your device does not support browser geolocation.",
    es: "Tu dispositivo no admite geolocalizacion en el navegador.",
    it: "Il dispositivo non supporta la geolocalizzazione nel browser.",
    fr: "Votre appareil ne prend pas en charge la geolocalisation dans le navigateur.",
    de: "Dein Geraet unterstuetzt keine Browser-Geolokalisierung.",
    "pt-PT": "O seu dispositivo nao suporta geolocalizacao no navegador.",
  },
  "O navegador pode bloquear GPS em HTTP. Para liberar no celular, use HTTPS ou localhost.": {
    en: "The browser may block GPS over HTTP. On mobile, use HTTPS or localhost.",
    es: "El navegador puede bloquear el GPS por HTTP. En movil, usa HTTPS o localhost.",
    it: "Il browser potrebbe bloccare il GPS su HTTP. Su mobile usa HTTPS o localhost.",
    fr: "Le navigateur peut bloquer le GPS en HTTP. Sur mobile, utilisez HTTPS ou localhost.",
    de: "Der Browser kann GPS ueber HTTP blockieren. Nutze auf Mobilgeraeten HTTPS oder localhost.",
    "pt-PT": "O navegador pode bloquear o GPS em HTTP. No telemovel, use HTTPS ou localhost.",
  },
  "Nao foi possivel usar a localizacao do dispositivo. Verifique as permissoes.": {
    en: "Could not use the device location. Check the permissions.",
    es: "No se pudo usar la ubicacion del dispositivo. Revisa los permisos.",
    it: "Impossibile usare la posizione del dispositivo. Controlla i permessi.",
    fr: "Impossible d'utiliser la position de l'appareil. Verifiez les autorisations.",
    de: "Der Geraetestandort konnte nicht verwendet werden. Pruefe die Berechtigungen.",
    "pt-PT": "Nao foi possivel usar a localizacao do dispositivo. Verifique as permissoes.",
  },
  "Seu navegador nao suporta notificacoes.": {
    en: "Your browser does not support notifications.",
    es: "Tu navegador no admite notificaciones.",
    it: "Il browser non supporta le notifiche.",
    fr: "Votre navigateur ne prend pas en charge les notifications.",
    de: "Dein Browser unterstuetzt keine Benachrichtigungen.",
    "pt-PT": "O seu navegador nao suporta notificacoes.",
  },
  "Voce precisa entrar na conta antes de excluir o cadastro.": {
    en: "You need to sign in before deleting the account.",
    es: "Debes iniciar sesion antes de eliminar la cuenta.",
    it: "Devi accedere prima di eliminare l'account.",
    fr: "Vous devez vous connecter avant de supprimer le compte.",
    de: "Du musst dich anmelden, bevor du das Konto loeschst.",
    "pt-PT": "Tem de iniciar sessao antes de eliminar a conta.",
  },
  "Informe sua senha atual para excluir a conta.": {
    en: "Enter your current password to delete the account.",
    es: "Introduce tu contrasena actual para eliminar la cuenta.",
    it: "Inserisci la password attuale per eliminare l'account.",
    fr: "Saisissez votre mot de passe actuel pour supprimer le compte.",
    de: "Gib dein aktuelles Passwort ein, um das Konto zu loeschen.",
    "pt-PT": "Indique a sua palavra-passe atual para eliminar a conta.",
  },
  "Digite \"DELETE\" para confirmar a exclusao da conta.": {
    en: "Type \"DELETE\" to confirm account deletion.",
    es: "Escribe \"DELETE\" para confirmar la eliminacion de la cuenta.",
    it: "Digita \"DELETE\" per confermare l'eliminazione dell'account.",
    fr: "Saisissez \"DELETE\" pour confirmer la suppression du compte.",
    de: "Gib \"DELETE\" ein, um das Loeschen des Kontos zu bestaetigen.",
    "pt-PT": "Escreva \"DELETE\" para confirmar a eliminacao da conta.",
  },
  "Erro ao excluir a conta.": {
    en: "Error deleting the account.",
    es: "Error al eliminar la cuenta.",
    it: "Errore durante l'eliminazione dell'account.",
    fr: "Erreur lors de la suppression du compte.",
    de: "Fehler beim Loeschen des Kontos.",
    "pt-PT": "Erro ao eliminar a conta.",
  },
  "Entre na conta para salvar enderecos.": {
    en: "Sign in to save addresses.",
    es: "Inicia sesion para guardar direcciones.",
    it: "Accedi per salvare gli indirizzi.",
    fr: "Connectez-vous pour enregistrer des adresses.",
    de: "Melde dich an, um Adressen zu speichern.",
    "pt-PT": "Entre na conta para guardar moradas.",
  },
  "Escolha um endereco ou use a localizacao antes de salvar.": {
    en: "Choose an address or use your location before saving.",
    es: "Elige una direccion o usa tu ubicacion antes de guardar.",
    it: "Scegli un indirizzo o usa la posizione prima di salvare.",
    fr: "Choisissez une adresse ou utilisez votre position avant d'enregistrer.",
    de: "Waehle eine Adresse oder nutze deinen Standort, bevor du speicherst.",
    "pt-PT": "Escolha uma morada ou use a localizacao antes de guardar.",
  },
  "Informe um valor-alvo valido para o alerta.": {
    en: "Enter a valid target price for the alert.",
    es: "Introduce un precio objetivo valido para la alerta.",
    it: "Inserisci un prezzo obiettivo valido per l'avviso.",
    fr: "Indiquez un prix cible valide pour l'alerte.",
    de: "Gib einen gueltigen Zielpreis fuer den Alarm ein.",
    "pt-PT": "Informe um preco-alvo valido para o alerta.",
  },
  "Ative ou salve sua localizacao antes de criar um alerta por distancia.": {
    en: "Enable or save your location before creating a distance-based alert.",
    es: "Activa o guarda tu ubicacion antes de crear una alerta por distancia.",
    it: "Attiva o salva la posizione prima di creare un avviso per distanza.",
    fr: "Activez ou enregistrez votre position avant de creer une alerte par distance.",
    de: "Aktiviere oder speichere deinen Standort, bevor du einen Entfernungsalarm erstellst.",
    "pt-PT": "Ative ou guarde a sua localizacao antes de criar um alerta por distancia.",
  },
  "Entre na conta para criar alertas da lista.": {
    en: "Sign in to create shopping-list alerts.",
    es: "Inicia sesion para crear alertas de la lista.",
    it: "Accedi per creare avvisi della lista.",
    fr: "Connectez-vous pour creer des alertes de liste.",
    de: "Melde dich an, um Listenalarme zu erstellen.",
    "pt-PT": "Entre na conta para criar alertas da lista.",
  },
  "Calcule e salve a lista antes de criar um alerta.": {
    en: "Calculate and save the list before creating an alert.",
    es: "Calcula y guarda la lista antes de crear una alerta.",
    it: "Calcola e salva la lista prima di creare un avviso.",
    fr: "Calculez et enregistrez la liste avant de creer une alerte.",
    de: "Berechne und speichere die Liste, bevor du einen Alarm erstellst.",
    "pt-PT": "Calcule e guarde a lista antes de criar um alerta.",
  },
  "Informe um valor-alvo total valido para a lista.": {
    en: "Enter a valid total target value for the list.",
    es: "Introduce un valor objetivo total valido para la lista.",
    it: "Inserisci un valore obiettivo totale valido per la lista.",
    fr: "Indiquez une valeur cible totale valide pour la liste.",
    de: "Gib einen gueltigen Gesamtzielwert fuer die Liste ein.",
    "pt-PT": "Informe um valor-alvo total valido para a lista.",
  },
  "Nao foi possivel registrar notificacoes neste dispositivo.": {
    en: "Could not register notifications on this device.",
    es: "No se pudieron registrar notificaciones en este dispositivo.",
    it: "Impossibile registrare le notifiche su questo dispositivo.",
    fr: "Impossible d'enregistrer les notifications sur cet appareil.",
    de: "Benachrichtigungen konnten auf diesem Geraet nicht registriert werden.",
    "pt-PT": "Nao foi possivel registar notificacoes neste dispositivo.",
  },
  "Erro ao aplicar endereco salvo.": {
    en: "Error applying the saved address.",
    es: "Error al aplicar la direccion guardada.",
    it: "Errore durante l'applicazione dell'indirizzo salvato.",
    fr: "Erreur lors de l'application de l'adresse enregistree.",
    de: "Fehler beim Anwenden der gespeicherten Adresse.",
    "pt-PT": "Erro ao aplicar a morada guardada.",
  },
  "Erro ao sincronizar notificacoes do dispositivo.": {
    en: "Error syncing device notifications.",
    es: "Error al sincronizar las notificaciones del dispositivo.",
    it: "Errore durante la sincronizzazione delle notifiche del dispositivo.",
    fr: "Erreur lors de la synchronisation des notifications de l'appareil.",
    de: "Fehler beim Synchronisieren der Geraetebenachrichtigungen.",
    "pt-PT": "Erro ao sincronizar as notificacoes do dispositivo.",
  },
};

Object.entries(RUNTIME_TRANSLATIONS).forEach(([source, translations]) => {
  Object.entries(translations).forEach(([language, translation]) => {
    if (LANGUAGE_FALLBACKS[language]) {
      LANGUAGE_FALLBACKS[language][source] = translation;
    }
  });
});

const PATTERN_TRANSLATORS_BY_LANGUAGE = {
  en: [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Product page ${product} opened.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Product form opened for ${market}.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `OCR mode opened for ${market}.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `Updating price for ${product}.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} opened from the distance ranking.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} opened from the ready stores list.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} opened from the store ranking.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} opened from the smart list.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} opened from search.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} opened from the product page.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} opened from search suggestions.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Alert created for ${product} within ${distance} ${unit}.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} results found for ${query}.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Enter a valid discovery radius in ${unit}.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Enter a valid maximum radius in ${unit} or leave it blank.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `${count} real places were synced within ${radius} of your location.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `${count} markets, supermarkets, pharmacies and convenience stores were loaded automatically within ${radius}.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Enable location to sync markets and stores within ${radius}.` },
  ],
  es: [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Pagina del producto ${product} abierta.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Formulario de producto abierto para ${market}.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `Modo OCR abierto para ${market}.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `Actualizando precio de ${product}.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} abierto desde el ranking de distancia.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} abierto desde la lista de tiendas listas.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} abierto desde el ranking de tiendas.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} abierto desde la lista inteligente.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} abierto desde la busqueda.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} abierto desde la pagina del producto.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} abierto desde las sugerencias de busqueda.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Alerta creada para ${product} hasta ${distance} ${unit}.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} resultados encontrados para ${query}.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Introduce un radio de descubrimiento valido en ${unit}.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Introduce un radio maximo valido en ${unit} o dejalo en blanco.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `Se sincronizaron ${count} lugares reales en un radio de ${radius} desde tu ubicacion.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `Se cargaron automaticamente ${count} mercados, supermercados, farmacias y tiendas de conveniencia en un radio de ${radius}.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Activa la ubicacion para sincronizar mercados y tiendas en un radio de ${radius}.` },
  ],
  it: [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Pagina prodotto ${product} aperta.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Modulo prodotto aperto per ${market}.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `Modo OCR aperto per ${market}.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `Aggiornamento prezzo di ${product}.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} aperto dalla classifica distanza.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} aperto dalla lista dei negozi pronti.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} aperto dalla classifica dei negozi.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} aperto dalla lista intelligente.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} aperto dalla ricerca.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} aperto dalla pagina prodotto.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} aperto dai suggerimenti di ricerca.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Avviso creato per ${product} entro ${distance} ${unit}.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} risultati trovati per ${query}.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Inserisci un raggio di scoperta valido in ${unit}.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Inserisci un raggio massimo valido in ${unit} oppure lascialo vuoto.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `${count} luoghi reali sono stati sincronizzati entro ${radius} dalla tua posizione.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `${count} mercati, supermercati, farmacie e minimarket sono stati caricati automaticamente entro ${radius}.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Attiva la posizione per sincronizzare mercati e negozi entro ${radius}.` },
  ],
  fr: [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Page produit ${product} ouverte.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Formulaire produit ouvert pour ${market}.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `Mode OCR ouvert pour ${market}.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `Actualisation du prix de ${product}.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} ouvert depuis le classement distance.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} ouvert depuis la liste des magasins prets.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} ouvert depuis le classement des magasins.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} ouvert depuis la liste intelligente.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} ouvert depuis la recherche.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} ouvert depuis la page produit.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} ouvert depuis les suggestions de recherche.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Alerte creee pour ${product} jusqu'a ${distance} ${unit}.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} resultats trouves pour ${query}.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Indiquez un rayon de decouverte valide en ${unit}.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Indiquez un rayon maximal valide en ${unit} ou laissez vide.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `${count} lieux reels ont ete synchronises dans un rayon de ${radius} autour de votre position.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `${count} marches, supermarches, pharmacies et magasins de proximite ont ete charges automatiquement dans un rayon de ${radius}.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Activez la localisation pour synchroniser les magasins dans un rayon de ${radius}.` },
  ],
  de: [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Produktseite ${product} geoffnet.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Produktformular fur ${market} geoffnet.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `OCR-Modus fur ${market} geoffnet.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `Preis fur ${product} wird aktualisiert.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} aus dem Entfernungsranking geoffnet.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} aus der Liste bereiter Laden geoffnet.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} aus dem Ladenranking geoffnet.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} aus der smarten Liste geoffnet.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} aus der Suche geoffnet.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} von der Produktseite geoffnet.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} aus den Suchvorschlagen geoffnet.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Alarm fur ${product} bis ${distance} ${unit} erstellt.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} Ergebnisse fur ${query} gefunden.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Gib einen gueltigen Entdeckungsradius in ${unit} ein.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Gib einen gueltigen Maximalradius in ${unit} ein oder lass das Feld leer.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `${count} echte Orte wurden im Umkreis von ${radius} um deinen Standort synchronisiert.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `${count} Maerkte, Supermaerkte, Apotheken und Convenience-Stores wurden automatisch im Umkreis von ${radius} geladen.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Aktiviere den Standort, um Maerkte und Geschaefte im Umkreis von ${radius} zu synchronisieren.` },
  ],
  "pt-PT": [
    { pattern: /^Pagina do produto (.+) aberta\.$/, format: ([, product]) => `Pagina do produto ${product} aberta.` },
    { pattern: /^Formulario de produto aberto para (.+)\.$/, format: ([, market]) => `Formulario de produto aberto para ${market}.` },
    { pattern: /^Modo OCR aberto para (.+)\.$/, format: ([, market]) => `Modo OCR aberto para ${market}.` },
    { pattern: /^Atualizando preco de (.+)\.$/, format: ([, product]) => `A atualizar preco de ${product}.` },
    { pattern: /^(.+) aberto pelo ranking de distancia\.$/, format: ([, market]) => `${market} aberto pelo ranking de distancia.` },
    { pattern: /^(.+) aberto pela lista de lojas prontas\.$/, format: ([, market]) => `${market} aberto pela lista de lojas prontas.` },
    { pattern: /^(.+) aberto pelo ranking de lojas\.$/, format: ([, market]) => `${market} aberto pelo ranking de lojas.` },
    { pattern: /^(.+) aberto pela lista inteligente\.$/, format: ([, market]) => `${market} aberto pela lista inteligente.` },
    { pattern: /^(.+) aberto pela busca\.$/, format: ([, market]) => `${market} aberto pela pesquisa.` },
    { pattern: /^(.+) aberto pela pagina do produto\.$/, format: ([, market]) => `${market} aberto pela pagina do produto.` },
    { pattern: /^(.+) aberto pelas sugestoes da busca\.$/, format: ([, market]) => `${market} aberto pelas sugestoes da pesquisa.` },
    { pattern: /^Alerta criado para (.+) ate ([\d.,]+)\s*(km|mi)\.$/, format: ([, product, distance, unit]) => `Alerta criado para ${product} ate ${distance} ${unit}.` },
    { pattern: /^(\d+) resultados encontrados para (.+)\.$/, format: ([, count, query]) => `${count} resultados encontrados para ${query}.` },
    { pattern: /^Informe um raio de descoberta valido em (.+)\.$/, format: ([, unit]) => `Informe um raio de descoberta valido em ${unit}.` },
    { pattern: /^Informe um raio maximo valido em (.+) ou deixe em branco\.$/, format: ([, unit]) => `Informe um raio maximo valido em ${unit} ou deixe em branco.` },
    { pattern: /^(\d+) locais reais foram sincronizados em um raio de (.+) da sua localizacao\.$/, format: ([, count, radius]) => `${count} locais reais foram sincronizados num raio de ${radius} da sua localizacao.` },
    { pattern: /^(\d+) mercados, supermercados, farmacias e conveniencias foram puxados automaticamente em um raio de (.+)\.$/, format: ([, count, radius]) => `${count} mercados, supermercados, farmacias e lojas de conveniencia foram carregados automaticamente num raio de ${radius}.` },
    { pattern: /^Ative a localizacao para sincronizar os mercados e lojas em um raio de (.+)\.$/, format: ([, radius]) => `Ative a localizacao para sincronizar os mercados e lojas num raio de ${radius}.` },
  ],
};

export function interpolateTranslation(text, params = {}) {
  return Object.entries(params || {}).reduce((current, [key, value]) => {
    return String(current).replaceAll(`{{${key}}}`, String(value ?? ""));
  }, String(text ?? ""));
}

export function translateFallbackText(language, text, params = {}) {
  if (text === undefined || text === null || text === "") {
    return "";
  }

  const normalizedText = String(text);
  const fallbackMap = LANGUAGE_FALLBACKS[language] || LANGUAGE_FALLBACKS["pt-BR"] || {};
  const patternTranslators = PATTERN_TRANSLATORS_BY_LANGUAGE[language] || [];
  const patternMatch = patternTranslators.find((entry) => normalizedText.match(entry.pattern));
  const translatedText =
    fallbackMap[normalizedText] ||
    (language !== "pt-BR" && patternMatch
      ? patternMatch.format(normalizedText.match(patternMatch.pattern))
      : "") ||
    (language !== "en" && language !== "pt-BR" && language !== "pt-PT"
      ? ENGLISH_FALLBACKS[normalizedText]
      : "") ||
    normalizedText;

  return interpolateTranslation(translatedText, params);
}
